import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },
}));

const CashPickUpAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [verificationId, setVerificationId] = useState('');

  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const validation = () => {
    let isError = false;
    if (!name.trim()) {
      console.log('name');
      handleSnakbarOpen('Please enter name', 'error');
      document.getElementById('name').focus();
      return (isError = true);
    }

    if (!mobileNumber.trim()) {
      console.log('mobileNumber');
      handleSnakbarOpen('Please enter mobile number', 'error');
      document.getElementById('mobileNumber').focus();
      return (isError = true);
    }
    if (!verificationId.trim()) {
      console.log('verificationId');
      handleSnakbarOpen('Please enter verification Id', 'error');
      document.getElementById('verificationId').focus();
      return (isError = true);
    }
    console.log('finish');
    return isError;
  };
  const clearStates = () => {
    setId('');
    setName('');
    setMobileNumber('');
    setVerificationId('');

    setStatus(false);
    setEditObj({});
  };

  const onSubmit = async e => {
    console.log('onSubmit');
    console.log('editIndexNo', editIndexNo);
    e.preventDefault();
    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      setLoading(true);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);
      try {
        if (addForm) {
          response = await axios({
            url: `/api/v1/private/beneficiary/${userId}/cashpickup`,
            method: 'post',
            data: { name, mobileNumber, verificationId, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('addForm Submit', name, mobileNumber, verificationId, status);
          setList([...list, response.data.data]);
          clearStates();
          console.log('addForm response', response);
        } else if (editForm) {
          response = await axios({
            url: `/api/v1/private/beneficiary/${userId}/cashpickup/${id}`,
            method: 'put',
            data: { name, mobileNumber, verificationId, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('editForm Submit', id, name, mobileNumber, verificationId, status);
          console.log('editForm response', response);

          list[editIndexNo] = response.data.data;
          setRefresh(!refresh);
        }

        closeAddDialog();
        activeAddForm();
        handleSnakbarOpen(response.data.message, 'success');
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setLoading(false);
      }
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  useEffect(() => {
    if (editObj.id) {
      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setName(editObj.name);
      setMobileNumber(editObj.mobileNumber);
      setVerificationId(editObj.verificationId);

      setStatus(editObj.status);
    }
  }, [editObj]);
  const activeAddForm = () => {
    clearStates();

    // setEditForm(false);
    // setAddForm(true);
  };

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);
  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        {editForm && (
          <div className={classes.iconDiv}>
            <IconButton aria-label="close" color="inherit" size="small" onClick={activeAddForm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          {editForm ? 'Update Person' : 'Add Person'}
        </Typography>
      </div> */}

      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Person' : 'Add Person'}
        </Typography>
      </div>

      <TextField
        id="name"
        label="Name"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <TextField
        id="mobileNumber"
        label="Mobile Number"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={mobileNumber}
        onChange={e => setMobileNumber(e.target.value)}
      />
      <TextField
        id="verificationId"
        label="Verification Id"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={verificationId}
        onChange={e => setVerificationId(e.target.value)}
      />

      <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div>
      {/* <div className={classes.marginStyle}>
        {loading ? <LinearProgress /> : null}
        <Button variant="contained" color="primary" disabled={loading} fullWidth onClick={onSubmit}>
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div> */}

      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default CashPickUpAddEdit;
